import { render, staticRenderFns } from "./CustomerServiceStatistics.vue?vue&type=template&id=54fa4c65&scoped=true&"
import script from "./CustomerServiceStatistics.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceStatistics.vue?vue&type=style&index=0&id=54fa4c65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa4c65",
  null
  
)

export default component.exports